import { render, staticRenderFns } from "./connect_box.vue?vue&type=template&id=56f1bcdc&scoped=true"
import script from "./connect_box.vue?vue&type=script&lang=js"
export * from "./connect_box.vue?vue&type=script&lang=js"
import style0 from "./connect_box.vue?vue&type=style&index=0&id=56f1bcdc&prod&scoped=true&lang=css"
import style1 from "./connect_box.vue?vue&type=style&index=1&id=56f1bcdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1bcdc",
  null
  
)

export default component.exports